// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_OEtF5{width:100%;background-color:#fde7e7;border:1px solid #fde7e7;border-radius:4px;margin:0;padding:0}.content_FIgEp{display:flex;justify-content:center;padding:12px 16px;grid-gap:12px;gap:12px}.icon_9Ykq\\+{display:flex;align-items:center;color:#856404;flex-shrink:0}.message_ag-ET{font-size:14px;line-height:1.4}@media(max-width:768px){.content_FIgEp{padding:10px 12px;grid-gap:8px;gap:8px}.message_ag-ET{font-size:13px}}", ""]);
// Exports
exports.locals = {
	"container": "container_OEtF5",
	"content": "content_FIgEp",
	"icon": "icon_9Ykq+",
	"message": "message_ag-ET"
};
module.exports = exports;
